import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute(
	'/(private)/bando/$residenceId/graduatoria/segnalazioni'
)({
	staticData: {
		breadcrumb: 'admin-ranking-reports:page_title'
	},
	component: () => <Outlet />
})
